import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-neutral-100" data-id="element-76" data-mp="38n415zsrtsyv">
      <div className="max-w-5xl mx-auto" data-id="element-77" data-mp="3djayj473pw57">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-neutral-900 text-center mb-12 uppercase" data-id="element-78" data-mp="3dm6tqkrke6py">
          Everything Included in <span className="text-amber-600" data-id="element-79" data-mp="3mlaeruaakw73">Heavy Equipment Instructor Atlas</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-80" data-mp="xthm4lzg5tpy">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-neutral-900 border-b-4 border-yellow-400 rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-81" data-mp="11tid163qfxdw">
              <Icon size={28} className="text-yellow-400" aria-hidden="true" data-id="element-82" data-mp="1da7vkx4aga6z" />
              <span className="text-white font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-83" data-mp="18bmtes5h7gfw">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-84" data-mp="14ce0fpi9fmle">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-neutral-200 rounded-xl p-4 flex items-center gap-3" data-id="element-85" data-mp="ujyhaov88ryx">
              <span className="w-9 h-9 rounded-lg bg-yellow-50 text-amber-600 flex items-center justify-center shrink-0" data-id="element-86" data-mp="pisnsotqt0oc">
                <Icon size={18} aria-hidden="true" data-id="element-87" data-mp="gk7954re65su" />
              </span>
              <span className="text-neutral-900 font-bold text-xs uppercase leading-tight" data-id="element-88" data-mp="gm9xlkcwbqvg">
                {label}
              </span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-amber-500 rounded-3xl p-8 md:p-12 shadow-xl shadow-neutral-900/10 text-center" data-id="element-89" data-mp="1w700mh0jqnf">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-8" loading="lazy" data-id="element-90" data-mp="kohxg0swewe5" />
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-neutral-900 mb-1" data-id="element-91" data-mp="pp5lcdltyx45">
            HEAVY EQUIPMENT INSTRUCTOR <span className="text-amber-600" data-id="element-92" data-mp="fwztd3vkwfoy">ATLAS</span>
          </p>
          <p className="text-base font-semibold text-neutral-900 mb-3" data-id="element-93" data-mp="fv6kdhxhtjds">
            The Complete Visual Heavy Equipment & Machinery Training System
          </p>
          <p className="text-base text-neutral-800/80 max-w-2xl mx-auto mb-8" data-id="element-94" data-mp="18elx5x2yubzv">
            A complete 6-in-1 professional visual training system created to help heavy equipment
            instructors prepare lessons, explain technical machinery concepts, organize training
            sessions and assess student understanding with more clarity, structure and confidence.
          </p>
          <p className="text-4xl md:text-5xl font-extrabold tracking-tight text-amber-600 mb-6" data-id="element-95" data-mp="2xw0occznftqb">
            $27 USD
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-96" data-mp="2a5n59bz1l57v">
            GET THE COMPLETE 6-IN-1 HEAVY EQUIPMENT INSTRUCTOR ATLAS NOW!
          </Button>
          <p className="text-xs text-neutral-800/60 mb-10" data-id="element-97" data-mp="2e6p5nw4p3nbf">
            Immediate Access · 6 Professional Volumes · 5 Bonuses · One-Time Payment
          </p>
          <div className="pt-8 border-t border-neutral-200" data-id="element-98" data-mp="3un1l7dlttb8k">
            <p className="text-2xl md:text-3xl font-bold tracking-tight text-neutral-900 mb-2 uppercase" data-id="element-99" data-mp="3plc9rwuoyvjy">
              Stop Planning Every Heavy Equipment Training Session From Scratch.
            </p>
            <p className="text-lg font-semibold text-amber-600" data-id="element-100" data-mp="tqizojzpdot0">
              OPEN IT. SHOW IT. EXPLAIN IT. TEACH IT.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}